let cache = null

export async function getReviewStats() {
    if (cache) return cache
    try {
        const res = await fetch(`/api/reviews-stats.json?t=${Date.now()}`)
        if (!res.ok) return {}
        cache = await res.json()
        return cache
    } catch {
        return {}
    }
}

export function getBusinessStats(stats, id) {
    const s = stats[`business:${id}`]
    if (!s) return { avg: 0, count: 0 }
    return { avg: s.avg || 0, count: s.count || 0 }
}
